import { render, staticRenderFns } from "./transferDialog.vue?vue&type=template&id=6ca92ae1&"
import script from "./transferDialog.vue?vue&type=script&lang=js&"
export * from "./transferDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports